import { lazy } from 'react';

export const CatalogUploadPageAsync = lazy(() => import('./CatalogUpload'));
